import {findAll} from "../../../../../modules/vegas/js/util";

const VGSocial = {
	init: function (self) {
		let cnt = self.dataset.social || 3,
			$child = self.childNodes,
			items = Array.from($child),
			transfer = [];

		if (items.length) {
			items = items.filter(function (item) {
				if (item.nodeName !== '#text') {
					return item;
				}
			});

			if (cnt > 1 && items.length > cnt) {
				items.forEach(function (value, key) {
					if (key > (cnt - 1)) {
						transfer.push(value);
						value.remove();
					}
				});
			}

			let lastElement = transfer[transfer.length - 1]
			if (lastElement) {
				let cloneLastElement = lastElement.cloneNode();

				cloneLastElement.classList.add('dropdown');
				cloneLastElement.classList.remove('me-1');
				cloneLastElement.innerHTML = '<a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fal fa-ellipsis-vertical"></i></a><ul class="dropdown-menu"></ul>'

				self.append(cloneLastElement);

				let dropdown = self.querySelector('.dropdown .dropdown-menu');

				transfer.forEach(function (item) {
					dropdown.append(item);
				});
			}
		}
	}
}

function onReady() {
	let socials = findAll('[data-social]');
	if (socials.length) {
		[...socials].map((social) => {
			VGSocial.init(social);
		});
	}
}

document.addEventListener("DOMContentLoaded", onReady);
if (window.Turbo !== 'undefined' && typeof onTurboRender === 'function') {
	onTurboRender(onReady);
}

export default VGSocial;
